import { CommApiInstance } from "Utils/CommApiInstance";


const AppLinkChngApi = async (
) => {
    return await CommApiInstance.post(`app/BBCAPP/link/chng`,{
        apiBody: {
        }
        
    })
    .then((Resp) => Resp.data);
}

export default AppLinkChngApi;